import { useEffect } from 'react';
import { getScheduleRunList } from '@/redux/requests/schedulesRequests.js';
import { getTriggerRunList } from '@/redux/requests/triggersRequests.js';
import { getWorkflow, listWorkflowRuns } from '@/redux/requests/workflowsRequests.js';

const REFRESH_MS = 5000;

const loadRuns = ({ kind, id }) => {
  if (kind === 'schedules') {
    return getScheduleRunList({ scheduleId: id });
  }

  if (kind === 'triggers') {
    return getTriggerRunList({ triggerId: id });
  }

  return listWorkflowRuns({ workflowId: id });
};

/**
 * Loads one automation's run history (and a workflow's steps) when its page opens. While a run is going,
 * or right after Run now, it refreshes the history every few seconds so new runs and their outcomes show up.
 */
const AutomationDetailStateHandler = ({ kind, id, watch }) => {
  useEffect(() => {
    if (kind === 'workflows') {
      getWorkflow({ workflowId: id });
    }
  }, [kind, id]);

  useEffect(() => {
    loadRuns({ kind, id });

    if (!watch) {
      return undefined;
    }

    const timer = setInterval(() => loadRuns({ kind, id }), REFRESH_MS);
    return () => clearInterval(timer);
  }, [kind, id, watch]);

  return null;
};

export default AutomationDetailStateHandler;
